<script setup>
import ContainerRoot from '@js/components/containers/ContainerRoot.vue';
import DialogModal from '@js/components/dialogs/DialogModal.vue';

const { title, content = undefined } = defineProps({
    title: {
        type: String,
        required: true,
    },
    content: {
        type: [String, Object],
        required: false,
    },
});
</script>

<template>
    <DialogModal size="medium">
        <template #trigger>
            <slot name="trigger" />
        </template>

        <template #title>
            {{ title }}
        </template>

        <template #content>
            <ContainerRoot>
                <div
                    v-if="content !== undefined && typeof content === 'string'"
                    class="wysiwyg"
                    v-html="content"
                ></div>

                <div v-else-if="content !== undefined" class="wysiwyg">
                    <component :is="content" />
                </div>

                <div v-if="$slots.content" class="wysiwyg">
                    <slot name="content" />
                </div>

                <slot v-if="$slots.complexContent" name="complexContent" />
            </ContainerRoot>
        </template>
    </DialogModal>
</template>
